import { Component, ElementRef, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { AuthenticationService } from '../../../services/auth-service';
import { UserAvatarService } from '../../../services/user-avatar-service';

@Component({
  selector: 'file-upload-comunicacion',
  template: '<input type="file" #fileInput>'
})
export class FileUploadComunicacionComponent {

  @ViewChild('fileInput') inputEl: ElementRef;

  @Output() fileSelected = new EventEmitter<{FormData: any, FileName: string}>();

  constructor(private http: Http,
              private authService: AuthenticationService,
              private avatarService: UserAvatarService) {}

  upload() {

    let inputEl: HTMLInputElement = this.inputEl.nativeElement;
    let fileCount: number = inputEl.files.length;
    let formData = new FormData();

    if (fileCount > 0) { // a file was selected
      let headers = new Headers();
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
      if (formData.has('file[]')) {
        formData.delete('file[]');
      }
      for (let i = 0; i < fileCount; i++) {
        formData.append('file[]', inputEl.files.item(i));
      }
      this.fileSelected.emit({FormData: formData, FileName: inputEl.files[0].name.toString()});
    }
  }

  click() {
    this.inputEl.nativeElement.click();
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/file-upload-comunicacion/file-upload-comunicacion.component.ts